import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Grid,
  Button,
  Divider,
  Switch,
  LinearProgress
} from '@material-ui/core';
import { Breadcrumb, BackdropCircular } from 'components';
import { getStoreConfigsApi, updateStoreConfigsApi, getRewardBehaviorRulesAPI, updateRewardBehaviorRuleAPI } from 'api';
import { changeStoreConfig } from 'redux/actions/store_configs';


export default function ReviewConf() {
  const dispatch = useDispatch();

  useEffect(() => {
    getStoreConfigsApi({dispatch});
    getRewardBehaviorRulesAPI({dispatch});
  }, []);

  const {storeConfigs, rewardBehaviorRules, loading, error} = useSelector((state) => state.store_configs);

  const reviewConfig = storeConfigs.find((config) => config.path === 'advanced/modules_disable_output/Magento_Review')?.value;
  const isReviewEnabled = reviewConfig == 0 || reviewConfig == null;

  const handleChange = (event) => {
    const {name, checked, type, value} = event.target;
    dispatch(changeStoreConfig(name, checked, type, value));
  };

  const handleSave = async () => {
    const ruleToUpdate = rewardBehaviorRules.find((rule) => rule.name.includes('Product Review'));
    const rule = { ...ruleToUpdate, is_active: isReviewEnabled};

    const isRuleUpdated = await updateRewardBehaviorRuleAPI({dispatch, rule});

    if (isRuleUpdated) {
      const configs = storeConfigs.filter((config) => {
        return (config.path === 'advanced/modules_disable_output/Magento_Review') || (config.path === 'catalog/review/allow_guest');
      });
      updateStoreConfigsApi({dispatch, configs});
    }
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div>
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'Store Configurations', path: '/settings#store_configurations' },
            { name: 'Product Reviews' }
          ]}
        />
      </div>
      <div className="mt-10 mx-10">
        <Card className="p-8">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <p className="text-gray">In this section you can allow or disallow customers to write reviews on products into your store</p>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            {loading && <LinearProgress />}
            {!loading && !error &&
            <>
              <Grid item xs={6}>
                Enable Product Reviews:
              </Grid>
              <Grid item xs={6}>
                <Switch
                  color="primary"
                  name="advanced/modules_disable_output/Magento_Review"
                  checked={isReviewEnabled}
                  onChange={handleChange}
                />
              </Grid>
              {isReviewEnabled &&
              <>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={6}>
                  Allow Guests to Write Reviews:
                </Grid>
                <Grid item xs={6}>
                  <Switch
                    color="primary"
                    name="catalog/review/allow_guest"
                    checked={storeConfigs.find((config) => config.path === 'catalog/review/allow_guest')?.value == 1}
                    onChange={handleChange}
                  />
                </Grid>
              </>
              }
            </>
            }
          </Grid>
        </Card>
        <div className="flex justify-end">
          <Button variant="contained" color="primary" className="my-10" onClick={handleSave}>Save Configurations</Button>
          <BackdropCircular loading={loading} />
        </div>
      </div>
    </div>
  );
}
